import React from 'react';

const BadgeCheckIcon: React.FC = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3.36252 12.9005C3.34329 13.0444 3.33355 13.1894 3.33335 13.3346C3.33335 15.3163 5.11502 16.9046 7.10085 16.638C7.67835 17.6663 8.77835 18.3346 10 18.3346C11.2217 18.3346 12.3217 17.6663 12.8992 16.638C14.8809 16.9046 16.6667 15.3163 16.6667 13.3346C16.6667 13.1905 16.6567 13.0455 16.6375 12.9005C17.665 12.323 18.3334 11.2221 18.3334 10.0013C18.3334 8.78047 17.665 7.67964 16.6375 7.10214C16.6567 6.95714 16.6667 6.81214 16.6667 6.66797C16.6667 4.6863 14.8809 3.09464 12.8992 3.36464C12.3217 2.3363 11.2217 1.66797 10 1.66797C8.77835 1.66797 7.67835 2.3363 7.10085 3.36464C5.11502 3.09464 3.33335 4.6863 3.33335 6.66797C3.33335 6.81214 3.34335 6.95714 3.36252 7.10214C2.33502 7.67964 1.66669 8.78047 1.66669 10.0013C1.66669 11.2221 2.33502 12.323 3.36252 12.9005ZM4.56419 8.39797L5.48252 8.1538L5.12085 7.2763C5.04153 7.08327 5.00049 6.87666 5.00002 6.66797C5.00002 5.7488 5.74752 5.0013 6.66669 5.0013C6.87252 5.0013 7.08252 5.04297 7.27502 5.12214L8.15335 5.4838L8.39752 4.56547C8.49156 4.21227 8.69966 3.90004 8.98946 3.67731C9.27925 3.45458 9.63452 3.33382 10 3.33382C10.3655 3.33382 10.7208 3.45458 11.0106 3.67731C11.3004 3.90004 11.5085 4.21227 11.6025 4.56547L11.8467 5.4838L12.725 5.12214C12.9175 5.04297 13.1275 5.0013 13.3334 5.0013C14.2525 5.0013 15 5.7488 15 6.66797C15 6.8738 14.9584 7.08463 14.8792 7.2763L14.5175 8.1538L15.4359 8.39797C15.7882 8.49318 16.0994 8.70182 16.3213 8.99164C16.5432 9.28145 16.6635 9.63629 16.6635 10.0013C16.6635 10.3663 16.5432 10.7212 16.3213 11.011C16.0994 11.3008 15.7882 11.5094 15.4359 11.6046L14.5175 11.8488L14.8792 12.7263C14.9584 12.918 15 13.1288 15 13.3346C15 14.2538 14.2525 15.0013 13.3334 15.0013C13.1275 15.0013 12.9175 14.9596 12.725 14.8805L11.8467 14.5188L11.6025 15.4371C11.5085 15.7903 11.3004 16.1026 11.0106 16.3253C10.7208 16.548 10.3655 16.6688 10 16.6688C9.63452 16.6688 9.27925 16.548 8.98946 16.3253C8.69966 16.1026 8.49156 15.7903 8.39752 15.4371L8.15335 14.5188L7.27502 14.8805C7.08197 14.9597 6.87537 15.0008 6.66669 15.0013C5.74752 15.0013 5.00002 14.2538 5.00002 13.3346C5.00002 13.1288 5.04169 12.918 5.12085 12.7263L5.48252 11.8488L4.56419 11.6046C4.21182 11.5094 3.90062 11.3008 3.67873 11.011C3.45683 10.7212 3.33659 10.3663 3.33659 10.0013C3.33659 9.63629 3.45683 9.28145 3.67873 8.99164C3.90062 8.70182 4.21182 8.49318 4.56419 8.39797Z'
        fill='url(#paint0_linear_4714_47079)'
      />
      <path
        d='M13.1183 8.92552L11.945 7.74219L9.16916 10.4914L8.08916 9.41135L6.91083 10.5897L9.16416 12.843L13.1183 8.92552Z'
        fill='url(#paint1_linear_4714_47079)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_4714_47079'
          x1='10'
          y1='1.66797'
          x2='10'
          y2='18.3346'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#6199FF' />
          <stop offset='1' stopColor='#045CFB' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_4714_47079'
          x1='10.0146'
          y1='7.74219'
          x2='10.0146'
          y2='12.843'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#6199FF' />
          <stop offset='1' stopColor='#045CFB' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default BadgeCheckIcon;
